import { CallOptions } from '@wui/jssip/lib/UA'

import { useUserMediaStream } from '@/shared/composables/media-stream'

import { getPcConfig } from './pc-config'

export const getOfferOptions = async (audioEnabled: boolean, videoEnabled: boolean, useMediaStubs = false, ...extraHeaders: string[]): Promise<CallOptions> => {
  const options: CallOptions = {
    mediaConstraints: {
      audio: useMediaStubs ? true : audioEnabled,
      video: useMediaStubs ? true : videoEnabled,
    },
    rtcOfferConstraints: {
      offerToReceiveAudio: true,
      offerToReceiveVideo: useMediaStubs ? true : videoEnabled,
      iceRestart: false,
    },
    pcConfig: getPcConfig(),
    extraHeaders: [
      ...extraHeaders,
      `X-Satel-Params: MuteMyVideo=${!videoEnabled};MuteMyAudio=${!audioEnabled}`,
    ],
  }
  const mediaStream = await useUserMediaStream().getUserMedia(audioEnabled, videoEnabled, useMediaStubs)
  options.mediaStream = mediaStream
  return options
}
